export const CHURNZERO_CONSTANT = {
  LOGIN: 'Vizzle Educator Login',
  SETUP: 'Vizzle Setup/Prep',
  USAGE: 'Vizzle Educator Usage',
};
